export const configurationKeys = {
  get: (config: string) => ["configuration", config] as const,
  getEquiment: (config: string, service: string) =>
    ["equimentConfiguration", config, service] as const,
};
